<template>
  <div
      class="editor-wrap"
      ref="editorWrap"
      v-check-fullscreen
  >

    <div
        v-show="editorObj.display.wysiwyg"
        class="wysiwig-wrap"
    >
      <!-- TODO buttons -->
      <div
          class="btns-wrap btn-nav-bar mb-1"
      >
        <template
            v-for="(button, index) in buttons"
        >
          <div
           class="input-group d-inline me-1 mb-1"
          >
            <div
                @click.prevent="onEditorButtonClick(index)"
                :class="'btn btn-sm btn-outline-secondary' + (button.isActive? ' active': '') + (button.isDisabled? ' disabled': '')"
                tabindex="0"
            >
              <i
                  v-if="button.ico.class"
                  :class="button.ico.class"
              />
              <span
                  class="ms-1 d-none d-md-inline"
              >
                {{$t(button.title)}}
              </span>
            </div>

            <div
                v-if="button.isActive && button.dialog"
                @click.prevent="onEditorButtonClickEdit(index)"
                class="btn btn-sm btn-outline-secondary"
            >
              <i class="bi bi-pen"/>
            </div>
            <i
                v-if="button.isActive"
                @click.prevent="onEditorButtonClickRemove(index)"
                class="btn btn-sm btn-outline-secondary bi bi-x text-danger"
                title="Odstanit element, obsah zustane"
            />

          </div>

        </template>

        <template v-if="renderSpecialButtons">
          <span
           class="me-2"
          >
            &nbsp;
          </span>
          <template
              v-for="(btn, index) in renderSpecialButtons"
          >
            <div
                v-if="btn.special"
            >

              <!---->
              <display-debug>
                <template #debugView>searchObj {{searchObj}}</template>
              </display-debug>


              <!-- searchPhrase -->
            </div>
            <div
              v-else
              class="input-group d-inline me-1 mb-1"

            >
              <span
                  class="btn btn-sm btn-outline-primary mb-1"
                  @click.prevent="clickSpecialButton(btn.onClick)"
              >
                 <i
                     v-if="btn.ico"
                     :class="btn.ico.class"
                 ></i>
                  <span
                      v-if="btn.title"
                      class="ms-1 d-none d-md-inline"
                  >
                    {{ $t(btn.title) }}
                  </span>
              </span>
            </div>
          </template>
        </template>
      </div>

      <!-- TODO editor -->

      <div
          class="content-wrap "
      >

        <!-- help window -->
        <div
            v-if="helpObj.display && displaySpecials.help"
            class="layer layer-top"
        >
          <div class="layer-wrap">
            <div class="layer layer-top center-center">
              <div class="modal form-wrap form-overflow">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">Napoveda</h5>
                      <button
                          @click.prevent="helpObj.display=false;"
                          type="button" class="btn-close btn-sm"
                      ></button>
                    </div>
                    <div class="modal-body">


                      <ul
                          v-if="helpObj.data"
                          class="nav"
                      >

                        <li
                            v-for="(section, s_index) in helpObj.data"
                            class="nav-item"
                        >
                          <a
                              @click.prevent="toogleHelpItem(s_index)"
                              :class="'nav-link' + (section.display? ' disabled': '')"
                              href="#"
                          >
                            {{$t(section.title)}}
                          </a>
                        </li>
                      </ul>


                      <div
                          v-for="(section, s_index) in helpObj.data"
                      >
                        <div>
                          <div
                              v-if="section.display"
                              class="accordion"
                          >
                            <div
                                v-for="(item, i_index) in section.items"
                                class="accordion-item"
                            >
                              <h2 class="accordion-header">
                                <button
                                    @click.preven="toogleHelpItem(s_index, i_index)"
                                    :class="'accordion-button __collapsed'  + (item.display?'':' collapsed') "
                                    type="button"
                                    aria-expanded="false"
                                >
                                  <i v-if="item.ico" :class="item.ico.class + ' me-2'"/>
                                  <span class="fs-5"> {{$t(item.title + '.title')}}</span>
                                </button>

                              </h2>
                              <div
                                  :class="'accordion-collapse' + (item.display?' open':' collapse')"
                              >
                                <div class="accordion-body">
                                  {{$t(item.content)}}
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="layer layer-bottom background-fill">
              &nbsp;
            </div>
          </div>
        </div>
        <!-- help window end-->

        <!-- dialog -->
        <div
            v-if="dialog && dialog.display"
            class="layer layer-top"
        >
          <div class="layer-wrap">
            <div class="layer layer-top center-center">
              <div class="modal form-wrap form-overflow">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">{{$t(dialog.title)}}</h5>
                      <button
                          @click.prevent="closeDialog();"
                          type="button" class="btn-close btn-sm"
                      ></button>
                    </div>
                    <div class="modal-body">

                      <!-- TODO innerHTML -->
                      <div
                          v-if="currentElement.definition.isWrap"
                      >
                        <div
                            class="input-group mb-2"
                        >
                          <label class="input-group-text">{{ $t('wysiwyg.action.link.dialog.marked_text.title') }}</label>

                          <div
                            contenteditable="true"
                            class="cms-form-input-oneline form-control"
                            style="height: 2.5rem; min-height: 2.5rem;"
                            data-name="dialog.innerHTML"
                            @input="onRichInput"
                            v-html="dialog.innerHTML"
                          />
                        </div>
                      </div>



                      <div
                          v-for="(item, index) in dialog.inputs"
                      >


                        <template
                          v-if="1==1"
                        >
                          [dialog.inputs]
                        </template>

                          <template
                              v-if="item.type == 'text'"
                          >
                            <div
                                class="input-group mb-2"
                            >
                              <label class="input-group-text">{{ $t(item.title) }}</label>
                              <input
                                  type="text"
                                  v-model="dialog.values[index]"
                                  :required="item.isMandatory? 'required': ''"
                                  :placeholder="(item.placeholder && $t(item.placeholder)? $t(item.placeholder): '[todo placeholder]')"
                                  class="form-control"
                              />
                            </div>
                          </template>
                          <template
                              v-else-if="item.type == 'select'"
                          >
                            <div
                                class="input-group mb-2"
                            >
                              <label class="input-group-text">{{$t(item.title)}}</label>
                              <select
                                  v-model="dialog.values[index]"
                                  class="form-select"
                              >
                                <option
                                    v-for="(option, index) in item.select"
                                    :value="index"
                                >
                                  {{$t(option.title)}}
                                </option>
                              </select>
                            </div>
                          </template>
                          <template
                              v-else-if="item.type == 'bool'"
                          >
                            <div
                                class="form-check form-switch mb-2"
                            >
                              <input
                                  v-model="dialog.values[index]"
                                  :id="'special_dialog_' + index"
                                  type="checkbox"
                                  :placeholder="($t(item.placeholder)? $t(item.placeholder): '[placeholder]')"
                                  class="form-check-input"
                                  value="1"
                              >
                              <label
                                  :for="'special_dialog_' + index"
                                  class="form-check-label"
                              >
                                {{$t(item.title)}}
                              </label>
                            </div>
                          </template>
                          <template
                              v-else-if="item.type == 'btn_submit'"
                          >
                            <div
                                class="-btn-group mb-2"
                            >
                              <template
                                  v-for="(btn) in item.content"
                              >
                                <div
                                    :class="'btn me-1 ' + ((dialog.values[index] == btn.value)? 'btn-primary': 'btn-outline-primary')"
                                    @click.prevent="dialog.values[index]=btn;submitDialog();"
                                >
                                  <!--  @click.prevent="dialog.values[index]=btn.value;submitDialog();" -->
                                  {{ $t(btn.title) }}


                                </div>
                              </template>
                            </div>

                          </template>
                          <template
                              v-else
                          >
                            <display-debug>
                              <template #debugView>input item bez definice {{item}}</template>
                            </display-debug>
                          </template>





                        <div
                            v-if="item.err"
                            class="text-danger mb-2"
                        >
                          <i class="bi bi-exclamation-triangle me-1"></i>{{item.err}}
                        </div>
                      </div>
                    </div>

                    <div
                        v-if="dialog.btn_footer"
                        class="modal-footer"
                    >
                      <button
                          @click.prevent="submitDialog()"
                          class="btn btn-sm btn-success me-2"
                      >
                        <i class="bi bi-check2"></i> {{ $t('wysiwyg.dialog.submit.title') }}
                      </button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div class="layer layer-bottom background-fill">
              &nbsp;
            </div>
          </div>
        </div>
        <!-- dialog end-->
        <div
            class="layer layer-bottom p-1 form-parent"
        >

          <div
            v-if="searchObj.display"
            class="search-wrap"
          >
            <div
                class="input-group"
            >
              <label
                  class="input-group-text"
                  for="search_object"
              >
                {{ $t('wysiwyg.action.search.dialog.find.title') }}
              </label>

              <input
                  type="search"
                  v-model="searchObj.model"
                  :placeholder="$t('wysiwyg.action.search.dialog.find.placeholder')"
                  class="form-control d-inline-block"
                  id="search_object"
              >

              <template
                v-if="searchObj.isReplacement"
              >
                <input
                    type="search"
                    v-model="searchObj.replacePhrase"
                    :placeholder="$t('wysiwyg.action.search.dialog.replace.placeholder')"
                    class="form-control d-inline-block"
                >
              </template>

              <span
                  class="input-group-text"
                  v-if="searchObj.err"
              >
                <span class="text-danger">
                  <i class="bi bi-exclamation-triangle me-1"></i>
                  <span v-html="searchObj.err"></span>
                </span>
              </span>

              <span
                  class="input-group-text"
                  v-if="searchObj.info"
              >
                <span class="text-muted">
                  <span v-html="searchObj.info"></span>
                </span>
              </span>

              <label
                  class="input-group-text"
                  for="replace_option"
              >
                <input
                    type="checkbox"
                    id="replace_option"
                    class="ps-1"
                    v-model="searchObj.isReplacement"
                />
                &nbsp;
                {{ $t('wysiwyg.action.search.dialog.replace.title') }}
              </label>

              <template
                  v-if="searchObj.isReplacement"
              >
                <span
                  class="btn btn btn-secondary -disabled"
                  title="Vyhledat"
                  @click.prevent="replaceInWysiwyg()"
                >
                  {{ $t('wysiwyg.action.search.dialog.replace.button') }}
                  <i
                      class="bi bi-repeat ms-1"
                  />
                </span>

              </template>
              <span
                  v-else
                  class="btn btn btn-secondary"
                  :title="$t('wysiwyg.action.search.dialog.button.title')"
                  @click.prevent="searchInWysiwyg()"
              >
                  <i
                      class="bi bi-search"
                  />
              </span>
            </div>
          </div>

          <div
              ref="editorWysiwygBody"
              contenteditable="true"
              class="editor-body form-control p-3"
              @input="onEditorWysiwygChange()"
              @paste="onEditorPaste"
              v-check-keydown
              @keydown="onEditorWysiwygKeydown"
              @click.prevent="onEditorWysiwygTextSelection()"
          />

          <!--


           -->


          <!--

          @keypress="onEditorKeyEnter"

              @input="onEditorInput()"
              @click="updateTextSelection()"
              @keydown="updateTextSelection()"
              @paste="onEditorPaste"
              @keypress="onEditorKeyEnter"
              @blur="onBlurEditor()"
          -->
        </div>
      </div>
    </div>

    <div
        v-show="editorObj.display.code"
        class="code-wrap"
    >
      <span
        class="btn btn-sm btn-outline-primary mb-1"
        @click.prevent="switchEditor()"
      >
        <i class="bi bi-easel"></i>
        {{ $t('wysiwyg.code_editor.editor.title') }}
      </span>
      <textarea
          ref="editorCode"
          v-model="editorObj.data.code"
          class="form-control html-code"
          @input="updateEditor()"
      />
    </div>



  </div>

  <!--
  <display-debug>
    <template #debugView>editorObj {{editorObj}}</template>
  </display-debug>



  <display-debug>
    <template #debugView>contentSelection {{contentSelection}}</template>
  </display-debug>

  <display-debug>
    <template #debugView>dialog {{dialog}}</template>
  </display-debug>


  <display-debug>
    <template #debugView>buttons {{buttons}}</template>
  </display-debug>


   <display-debug>
    <template #debugView>searchObj {{searchObj}}</template>
  </display-debug>



  <display-debug>
    <template #debugView>displaySpecials {{displaySpecials}}</template>
  </display-debug>
  <display-debug>
    <template #debugView>renderSpecialButtons {{renderSpecialButtons}}</template>
  </display-debug>


  <display-debug>
    <template #debugView>editorObj {{editorObj.data.code}}</template>
  </display-debug>





  <display-debug>
    <template #debugView>currentElement {{currentElement}}</template>
  </display-debug>


  -->


</template>

<script>
import {defaultEditorConfig} from "./htmlEditorConfigDefault.js";
import  "./htmlEditor.scss";
//import {type} from "@vueuse/core/index";
import axios from "axios";
import general from "@/components/config/general";
export default {
  name: "htmlEditor v2",
  props: {
    "modelValue": {
      type: [String, Number, Object],
      required: false,
    },
    "inputData": {
      type: [String, Number, Object],
      required: false,
    },
    "editorType": {
      type: [String, Number],
      required: false,
      default: null,
    },
    "editorConfig": {
      type: [Object, Array],
      required: false,
      default: null,
    },
    "config": {
      type: [Object],
      required: false,
      default: {
        attributes: {
          element_id_name: 'data-cms-element-id',
          element_typ_name: 'data-cms-element-type',
          element_values_name: 'data-cms-element-form-inputs',
        },
        action: {
          create: 'create',
          edit: 'edit',
          delete: 'delete',
        },
        timerObj: {
          mounted: null,
          renderDelay: null,
          onMounted: null,
          onClickLoadAttr: null,
          codeType: null,
          clearCode: null,
        },
        timer: {
          renderDelay: 10,
          onMounted: 5,
          onClickLoadAttr: 1,
          codeType: 500,
          clearCode: 750,
        }
      }
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      inputModel: null,
      editorObj: {
        data: {
          code: null,
          wysiwyg: null
        },
        display: {
          code: false,
          wysiwyg: true,
        }
      },
      contentSelection: {
        elementId: null, //id vybraneho elementu pri editace
        selection: null,
        range: null,
        elementNode: null,
        button: null,
        innerText: null,
        htmlSelection: null,

        //action: null,
        //
        //isCollapsed: null,
        //
       //
        //rangeEdited: null,
      },
      buttons: {},
      specialButtons: {},
      currentElement: {
        action: null,
        definition: null,
        data: null,
      },
      dialog: { // todo struktura
          display: false,
          title: null,
          values: null,
          inputs: null,
          btn_footer: null,
          innerHTML: null,
      },
      displaySpecials: { //displaySpecials.removeElement
        clearFormatComplete: true,
        removeElement: false,
        fullscreenToggleOn: true,
        fullscreenToggleOff: false,
        switchEditorToCode: true,
        search: true,
        help: true,
      },
      searchObj: {
        display: false,
        model: 'milei', //milei, e
        phrase: null,
        replacePhrase: null,
        resultIndex: null,
        results: null,
        isReplacement: false,
        err: null,
      },
      helpObj: {
        display: false,
        data: false,
      },
      customButtonsDefinition: null,
    }
  },
  created() {
    //console.clear() //DEV
    //this.prefillData();
  },
  mounted() {
    if(localStorage.getItem(general.lang_id_local_storage_name)) {
      //this.setActiveLang(localStorage.getItem(general.lang_id_local_storage_name));
    }
    /*
        console.log('dev mounted config', this.config)
        console.log('dev mounted config defaultEditorConfig', defaultEditorConfig.config)
    */
    this.config.timerObj.mounted = setTimeout(() => {
          this.prefillData();
          this.loadCustomButtons();
          this.updateButtons();
          this.updateSpecialButtonDisplay();
          this.isHelpObj();
        },
        this.config.timer.renderDelay
    );

  },

  directives: {
    'checkFullscreen': { beforeMount(el, binding) {
        const componentInstance = binding.instance;
        el.checkFullscreen = () => {
          if (!document.fullscreenElement) {
            componentInstance.displaySpecials.fullscreenToggleOn = true;
            componentInstance.displaySpecials.fullscreenToggleOff = false;
          }
        };
        document.body.addEventListener('fullscreenchange', el.checkFullscreen);
      },
      unmounted(el) {
        document.body.removeEventListener('fullscreenchange', el.checkFullscreen);
      }
    },
    'checkKeydown': { beforeMount(el, binding) {
        const componentInstance = binding.instance;
        el.checkKeydown = (event) => {
          componentInstance.onEditorKeyEnter(event);
          //console.log('[htmlEditor.checkKeydown]', event.keyCode, event.key, event);
        };
        document.body.addEventListener('keydown', el.checkKeydown);
      },
      unmounted(el) {
        document.body.removeEventListener('keydown', el.checkKeydown);
      }
    },

  },

  computed: {
    renderSpecialButtons() {
      const buttons = {};
      const specials = this.specialButtons


      for(const i in specials) {
        //console.log('[htmlEditor.renderSpecialButtons]', i, this.specialsDefinition[i]);
        if(
            this.isDisplaySpecialButton(
                i,
                (typeof specials[i].displayMethod != "undefined"? specials[i].displayMethod: null)
            )
        ) {
          buttons[i] = specials[i];
        }

      }

      if(Object.keys(buttons).length > 0) {
        return buttons;
      } else{
        return null;
      }
    }
  },
  methods: {
    prefillData() {
      if(this.modelValue) {
        this.editorObj.data = {
          wysiwyg: this.modelValue,
          code: this.modelValue,
        }
        if(this.$refs.editorWysiwygBody) {
          this.$refs.editorWysiwygBody.innerHTML = this.editorObj.data.wysiwyg;
        }
        this.inputModel = this.modelValue;
      }
    },

    updateButtons() {
      this.buttons = {};
      //let buttons = Object.assign(this.buttonsDefinition);
      let buttons = Object.assign(defaultEditorConfig.buttonsDefinition.default);

      if(
          this.editorConfig
          && this.editorConfig.config
          && this.editorConfig.config.buttons
          && Object.keys(this.editorConfig.config.buttons).length > 0
      ) {
        for(const b in buttons) {
          if(
              typeof this.editorConfig.config.buttons[b] !== "undefined"
          ) {
            Object.assign(
                buttons[b],
                this.editorConfig.config.buttons[b]
            );
          }else{
            delete buttons[b];
          }
        }
      }
      //this.specialButtons = this.specialsDefinition;
      this.specialButtons = defaultEditorConfig.specialsDefinition.default;

      if(this.customButtonsDefinition) {
        buttons = this.customButtonsDefinition;
      }

      for(const i in buttons) {
        buttons[i].isDisabled = true;
        //buttons[i].isActive = false;
        if(
            buttons[i].isWrap == true
            && !this.contentSelection.isCollapsed
            && this.contentSelection.htmlSelection != null
        ){
          buttons[i].isDisabled = false;
          //console.log('[htmlEditor.updateButtons] BTN WRAP', buttons[i])
        }else if(
            buttons[i].isWrap == false
            && this.contentSelection.isCollapsed
            && this.contentSelection.htmlSelection != null
        ) {
          buttons[i].isDisabled = false;
        }

        // active
        //buttons[i].isActive = false; //standartni nastaveni

        if(
            this.contentSelection.button
            && typeof defaultEditorConfig.buttonsDefinition.default[this.contentSelection.button] != "undefined"
            && i == this.contentSelection.button
        ){
          buttons[i].isActive = true;
          buttons[i].isDisabled = false;
        }else{
          buttons[i].isActive = false;
        }

        /*
        if(
            this.contentSelection.button
            && typeof this.buttonsDefinition[this.contentSelection.button] != "undefined"
            && i == this.contentSelection.button
        ){
            buttons[i].isActive = true;
            buttons[i].isDisabled = false;
        }else{
            buttons[i].isActive = false;
        }
        */
      }
      this.buttons = buttons;
    },

    loadCustomButtons() {
      if(this.editorType) {
        console.log('[htmlEditor.loadCustomButtons] this.editorType', this.getApiConfig('wysiwyg.buttons.path') +'?type=' + this.editorType)
        let formData = new FormData();
        formData.append('type', this.editorType);
        formData.append('buttons', JSON.stringify(this.buttonsDefinition));
        //formData.append('special_buttons', JSON.stringify(this.specialsDefinition));
        formData.append('special_buttons', JSON.stringify(this.specialsDefinition));


        axios.defaults.baseURL = this.getBaseRoot();
        axios({
          method: 'post',
          url: this.getApiConfig('wysiwyg.buttons.path') +'?type=' + this.editorType,
          data: formData,
          withCredentials: true,
          headers: this.getRequestHeader(),
        }).then((res) => {
          //console.log('[htmlEditor.loadCustomButtons] RES.buttons',  res.data.response)
          //console.log('[htmlEditor.loadCustomButtons] RES', res.data)
          if(res.data.status) {
            this.buttons = res.data.response.buttons;
            this.specialButtons = res.data.response.special_buttons;
          }
        }).catch(function(err){
          console.log('[htmlEditor.loadCustomButtons] ERR',  err )
        })
      }

    },

    updateCode(){
      this.editorObj.data.wysiwyg = this.$refs.editorWysiwygBody.innerHTML;
      this.editorObj.data.code = this.$refs.editorWysiwygBody.innerHTML;
    },

    updateEditor(){
      this.$refs.editorWysiwygBody.innerHTML = this.editorObj.data.code;
    },

    onEditorButtonClick(ident) {

      this.contentSelection.button = ident

      if(this.buttons[ident].isActive == true) {
        this.currentElement.action = 'delete'
        this.removeElement(ident)
      }else{
        this.currentElement.action = 'new'
        this.prepareElement(ident)
      }

      this.updateButtons();
    },

    onEditorButtonClickEdit(ident) {
      //console.log('[htmlEditor.onEditorButtonClickEdit]', ident)
      //console.log('[htmlEditor.onEditorButtonClickEdit]', this.dialog)

      if(!this.dialog.display) {
        const elementType = this.getElementType(document.getSelection().anchorNode.parentNode);
        if(elementType) {
          this.prepareElement(elementType);
          //this.displaySpecials.removeElement = false;
        }else{

          //this.displaySpecials.removeElement = true;
        }

        this.contentSelection.elementNode =  document.getSelection().anchorNode.parentNode;

        if(
            document.getSelection().anchorNode.parentNode.innerHTML
            && this.contentSelection.isCollapsed
        ) {
          //console.log('[htmlEditor.onEditorWysiwygTextSelection] TEXT',this.contentSelection.isCollapsed, document.getSelection().anchorNode)
          this.contentSelection.innerText = '' + (document.getSelection().anchorNode.textContent || document.getSelection().anchorNode.nodeValue)
        }
      }else{
        //close
        this.dialog.display = false;
      }





    },

    onEditorButtonClickRemove(ident) {
      this.contentSelection.button = ident
      this.currentElement.action = 'delete'
      //this.removeElement(ident)


      if(this.buttons[ident].isActive == true) {
        this.removeElement(ident)
      }

      //console.log('[htmlEditor.onEditorButtonClickRemove]', ident)
    },

    onEditorWysiwygChange(event) {

      if(this.config.timerObj.typeCode) clearInterval(this.config.timerObj.typeCode);
      this.config.timerObj.typeCode = setTimeout(
          () => {
            //console.log('[htmlEditor.onEditorWysiwygChange]')
            this.onEditorChange();
            this.updateCode();
          },
          this.config.timer.typeCode
      )
    },

    onEditorWysiwygKeydown(){
      this.selectElementBySelection();
    },

    selectElementBySelection(){
      //console.log('[htmlEditor.selectElementBySelection]')
      const selection = document.getSelection()
      this.contentSelection.selection = selection;
      this.contentSelection.range = selection.getRangeAt(0);
      this.contentSelection.isCollapsed = selection.isCollapsed;

      if(
          selection.rangeCount
          && !selection.isCollapsed
      ) {
        this.contentSelection.innerText =  '' + window.getSelection()

        const myRange = selection.getRangeAt(0);
        const tempDiv = document.createElement('div');
        tempDiv.appendChild(myRange.cloneContents())

        this.contentSelection.htmlSelection = tempDiv.innerHTML
      }

      if(this.config.renderDelay) clearInterval(this.config.timerObj.renderDelay);
      this.config.timerObj.renderDelay = setTimeout(
          () => {


            if(document.getSelection().anchorNode.parentNode != this.$refs.editorWysiwygBody) {
              this.currentElement.action = 'edit';
              const elementType = this.getElementType(document.getSelection().anchorNode.parentNode);
              this.contentSelection.button = elementType;
              this.contentSelection.elementNode =  document.getSelection().anchorNode.parentNode;

              if(
                  elementType
                  && typeof this.buttons[elementType] != "undefined"
              ) { //todo blba podminka
                this.displaySpecials.removeElement = false;
              }else{
                this.displaySpecials.removeElement = true;
              }
            }else{
              this.contentSelection.button = null;
            }
            this.updateButtons();
            this.updateCode();

          },
          this.config.timer.renderDelay
      )
    },

    onEditorWysiwygTextSelection() {
      //FIX samovolne mazani obsahu
      this.selectElementBySelection();

/*
      if(this.config.clearCode) clearInterval(this.config.timerObj.clearCode);
      this.config.timerObj.clearCode = setTimeout(
          () => {
            this.clearCode();
          },
          this.config.timer.clearCode
      )
      */
    },

    onEditorWysiwygTextSelection_BACKUP() {
      console.log('[htmlEditor.onEditorWysiwygTextSelection] ----------------------------------------------------------------------------')
      ///console.log('[htmlEditor.onEditorWysiwygTextSelection]')

      this.contentSelection.selection = window.getSelection();
      //console.log('[htmlEditor.onEditorWysiwygTextSelection] string', this.contentSelection.selection.toString())
      this.contentSelection.range = window.getSelection().getRangeAt(0);
      this.contentSelection.isCollapsed =  this.contentSelection.selection.isCollapsed;

      if(window.getSelection()){
        this.contentSelection.innerText =  '' + window.getSelection()
      }


      const selection = document.getSelection()
      if(
          selection.rangeCount
          && !selection.isCollapsed
      ) {
        const myRange = selection.getRangeAt(0);
        const tempDiv = document.createElement('div');
        tempDiv.appendChild(myRange.cloneContents())

        this.contentSelection.htmlSelection = tempDiv.innerHTML
      }


      if(this.config.renderDelay) clearInterval(this.config.timerObj.renderDelay);
      this.config.timerObj.renderDelay = setTimeout(
          () => {


            if(document.getSelection().anchorNode.parentNode != this.$refs.editorWysiwygBody) {
              this.currentElement.action = 'edit';
              const elementType = this.getElementType(document.getSelection().anchorNode.parentNode);
              this.contentSelection.button = elementType;
              this.contentSelection.elementNode =  document.getSelection().anchorNode.parentNode;

              //console.log('[htmlEditor.onEditorWysiwygTextSelection] elementType', elementType)
              if(
                elementType
                && typeof this.buttons[elementType] != "undefined"
              ) { //todo blba podminka
                this.displaySpecials.removeElement = false;
              }else{
                this.displaySpecials.removeElement = true;
              }

              /*
              const elementType = this.getElementType(document.getSelection().anchorNode.parentNode);
                            if(elementType) {
                              this.prepareElement(elementType);
                              //this.displaySpecials.removeElement = false;
                            }else{

                              //this.displaySpecials.removeElement = true;
                            }

                            this.contentSelection.elementNode =  document.getSelection().anchorNode.parentNode;

                            if(
                                document.getSelection().anchorNode.parentNode.innerHTML
                                && this.contentSelection.isCollapsed
                            ) {
                              //console.log('[htmlEditor.onEditorWysiwygTextSelection] TEXT',this.contentSelection.isCollapsed, document.getSelection().anchorNode)
                              this.contentSelection.innerText = '' + (document.getSelection().anchorNode.textContent || document.getSelection().anchorNode.nodeValue)
                            }
                            */
            }else{
              this.contentSelection.button = null;
            }
            this.updateButtons();
            this.updateCode();

          },
          this.config.timer.renderDelay
      )
    },

    onEditorChange() {
      //console.log('onEditorChange');
      this.cleanSearchResults();
    },

    onEditorKeyEnter(event) {

      if(this.editorObj.display.wysiwyg) {
        //console.log('onEditorKeyEnter', event);
        //console.log('onEditorKeyEnter', this.editorObj.display.wysiwyg);

        if (event.keyCode == 46) {
          if(event.shiftKey) {
            //console.log('Delete + SHIFT stisknuto ', event); // Proveďte zde požadovanou akci
            event.preventDefault();
          }else if(event.ctrlKey) {
            //console.log('Delete + CTRL stisknuto ', event); // Proveďte zde požadovanou akci
            event.preventDefault();
            this.removeListItem();
          }else{
            console.log('Delete stisknuto', event); // Proveďte zde požadovanou akci
          }

          //console.log('[htmlEditor.onEditorKeyEnter]', event)

        }else if(
            event.keyCode == 13
            && event.ctrlKey
        ) {
          //console.log('[htmlEditor.onEditorKeyEnter] CTRL ENTER', event)
          this.customCreateNewListItem(event);
        }else if(
            event.keyCode == 13
        ) {
          event.preventDefault();
          this.customBreakLine();

        }else{
          //console.log('[htmlEditor.onEditorKeyEnter]', event)
        }
      }
    },

    clearContentSelection(){
      //console.log('clearContentSelection');
      this.contentSelection = {
        elementId: null, //id vybraneho elementu pri editace
            selection: null,
            range: null,
            elementNode: null,
            button: null,
            innerText: null,
      }
    },

    removeListItem() {
      if(
          this.contentSelection.elementNode
          && this.contentSelection.elementNode.parentNode
          && (
            this.contentSelection.elementNode.parentNode.tagName == 'UL'
            || this.contentSelection.elementNode.parentNode.tagName == 'OL'
          )
      ){
        //console.log('removeListItem ITEM ', this.contentSelection.elementNode);
        this.moveCursorToElement(this.contentSelection.elementNode.parentNode)
        this.contentSelection.elementNode.parentNode.removeChild(this.contentSelection.elementNode);
        this.clearContentSelection();
      }
    },

    customBreakLine() {

        try {
          const newElement = document.createElement('br')
          const myRange = this.contentSelection.range

          myRange.deleteContents();
          myRange.insertNode(newElement);
          myRange.collapse(false);

          this.moveCursorToElement(newElement)
        }catch (e) {
          console.error('customBreakLine ERR', e)
        }

    },

    customCreateNewListItem(event) {
      event.preventDefault();
      if(
          this.contentSelection.elementNode
          && this.contentSelection.elementNode.parentNode
      ) {
        //console.log('[htmlEditor.onEditorKeyEnter] CTRL ENTER elementNode XXX', this.contentSelection.elementNode.parentNode.tagName)
        if(
            this.contentSelection.elementNode.parentNode.tagName == 'UL'
            || this.contentSelection.elementNode.parentNode.tagName == 'OL'
        ) {

          var index = Array.prototype.indexOf.call(
              this.contentSelection.elementNode.parentNode.children,
              this.contentSelection.elementNode
          );
          //console.log('[htmlEditor.onEditorKeyEnter] PORADI', index, this.contentSelection.elementNode.parentNode.children.length, this.contentSelection.elementNode )

          const listItem = document.createElement('li')
          //listItem.innerText = 'aaaaa'

          if(
              (parseInt(index) + 1 ) ==  this.contentSelection.elementNode.parentNode.children.length
          ) {
            //console.log('[htmlEditor.onEditorKeyEnter] CTRL ENTER poradi 1')
            this.contentSelection.elementNode.appendChild(listItem);
            this.moveCursorToElement(
                listItem
            );
          }else{
            //console.log('[htmlEditor.onEditorKeyEnter] CTRL ENTER poradi insertBefore')
            this.contentSelection.elementNode.parentNode.insertBefore(
                listItem,
                this.contentSelection.elementNode.parentNode.children[(index+1)]
            );
            this.moveCursorToElement(
                this.contentSelection.elementNode.parentNode.children[(index+1)]
            );
          }
        }
      }
    },

    moveCursorToElement(element) {
      let range = document.createRange();
      //var element = this.contentSelection.elementNode.parentNode.children[(index+1)];
      range.setStart(element, 0);
      range.setEnd(element, 0);
      this.contentSelection.selection.removeAllRanges();
      this.contentSelection.selection.addRange(range);
    },

    onEditorPaste(event){
      event.preventDefault();
      const htmlText = event.clipboardData.getData('text/html');
      this.pasteHtml(htmlText)
    },

    pasteHtml(html) {
      const range = document.createRange();
      range.selectNode(document.body);
      const documentFragment = range.createContextualFragment(html);

      documentFragment.childNodes.forEach(child => {
        if(
            child.nodeType != Node.TEXT_NODE
            && child.nodeType != Node.ELEMENT_NODE
        ) {
          documentFragment.removeChild(child);
        }
      });

      this.cleanPastedChild(documentFragment);

      const myRange = this.contentSelection.range
      myRange.deleteContents();
      myRange.insertNode(documentFragment);
      myRange.collapse(true);
    },

    cleanPastedChild(parent){
      if(parent.nodeType == Node.ELEMENT_NODE) {
        parent.removeAttribute('style');
      }else{
        //console.log('[htmlEditor.pasteHtml] cleanPastedChild ELSE',  parent.nodeType,  parent.childNodes, parent);
      }

      parent.childNodes.forEach(child => {
        if(child.nodeType == Node.ELEMENT_NODE) {
          child = this.cleanPastedChild(child);
        }
      });
      return parent;
    },

    onEditorCode(){
      console.log('[htmlEditor.onEditorCode] ')
    },
    onEditorWysiwyg(){
      console.log('[htmlEditor.onEditorWysiwyg]')
    },

    prepareElement(ident){

      this.displaySpecials.removeElement = false;
      //console.log('[htmlEditor.prepareElement]', ident)

      if(typeof this.buttons[ident] != "undefined") {
        this.currentElement.definition = this.buttons[ident];

        if(typeof this.currentElement.definition.dialog != "undefined"){
          if(this.config.renderDelay) clearInterval(this.config.timerObj.renderDelay);
          this.config.timerObj.renderDelay = setTimeout(
              () => {
                //console.log('[htmlEditor.prepareElement] DIALOG', this.currentElement.definition.dialog )
                this.prepareDialog(this.currentElement.definition.dialog );
                //nacteni attr

                if(this.currentElement.action == 'edit') {
                  this.sendDataToDialog();
                  /*
                  if(this.config.timerObj.onClickLoadAttr) clearInterval(this.config.timerObj.onClickLoadAttr);
                  this.config.timerObj.onClickLoadAttr = setTimeout(
                      () => {
                        this.sendDataToDialog();
                      },
                      this.config.timer.onClickLoadAttr
                  )
                  */
                }
              },
              this.config.timer.renderDelay
          )
        }else{

          if (this.currentElement.action == 'new') {
            //TODO wrap to method
            const attrs = {};
            const attrsDisplay = {};
            //this.currentElement.definition
            //console.log('[htmlEditor.prepareElement] ATTR', this.currentElement.definition.params)
            if(typeof this.currentElement.definition.params != "undefined") {
              for (const p in this.currentElement.definition.params) {
                //console.log('[htmlEditor.prepareElement] ATTR-p', p,this.currentElement.definition.params[p])
                if(typeof this.currentElement.definition.params[p] != "undefine") {
                  attrs[p] = this.currentElement.definition.params[p].value;
                  if(this.currentElement.definition.params[p].isRender) {
                    attrsDisplay[p] = this.currentElement.definition.params[p].value;
                  }
                }
              }
            }
            console.log('dev prepareElement new2', ident, attrs, attrsDisplay);


            //console.log('[htmlEditor.prepareElement] SIMPLE1')
            this.createElement2(
                {
                  tagName: this.currentElement.definition.tagName,
                  innerHtmlPlaceholder: this.currentElement.definition.innerHtmlPlaceholder,
                  innerContent: (this.currentElement.definition.isWrap? this.contentSelection.htmlSelection : null),
                  child: (this.currentElement.definition.child? this.currentElement.definition.child: null),
                  attrsDisplay,
                  attrs,
                }
            );
          }
        }

        /*
        if(this.currentElement.action == 'edit') {
          if(this.config.timerObj.onClickLoadAttr) clearInterval(this.config.timerObj.onClickLoadAttr);
          this.config.timerObj.onClickLoadAttr = setTimeout(
              () => {
                this.sendDataToDialog();
              },
              this.config.timer.onClickLoadAttr
          )

        }else if (this.currentElement.action == 'new') {
         // console.log('[htmlEditor.prepareElement] NEW', ident)
        }
        */

      }else{
        if(
            document.getSelection().anchorNode.parentNode != this.$refs.editorWysiwygBody
            && document.getSelection().anchorNode != this.$refs.editorWysiwygBody
        ) {
          this.displaySpecials.removeElement = true;
        }

      }
    },

    sendDataToDialog() {
      const attrs = {};
      if(this.contentSelection.elementNode) {
        //console.log('[htmlEditor.sendDataToDialog]', this.contentSelection.elementNode? true: false, typeof this.contentSelection.elementNode)

        const attributeNames = this.contentSelection.elementNode.getAttributeNames();
        attributeNames.forEach(name => {
          attrs[name] = this.contentSelection.elementNode.getAttribute(name);
        });

        if(
            this.contentSelection.elementNode.getAttribute(this.config.attributes.element_values_name)
        ) {

          let inputAttr = this.contentSelection.elementNode.getAttribute(this.config.attributes.element_values_name)
          if(inputAttr) {
            inputAttr = JSON.parse(inputAttr)
            for(const i in inputAttr) {
              attrs[i] = inputAttr[i];
            }
              delete attrs[this.config.attributes.element_values_name]
          }
        }
      }
      if(
          this.dialog
          //&& this.dialog.inputs
          && attrs
      ){
        //console.log('[htmlEditor.sendDataToDialog] ATTR x values', this.dialog)
        for(const i in this.dialog.inputs) {
          if(
              typeof attrs[i]
              && attrs[i]
          ) {
            this.dialog.inputs[i].value = attrs[i]
          }
          //console.log('[htmlEditor.sendDataToDialog] ATTR x values', this.dialog.inputs[i])
        }


      }
      this.dialog.values = attrs;
    },

    prepareDialog(config){
      //console.log('[htmlEditor.prepareDialog]', config)

      const dialog = {
        //display: true,
        title: config.title,
        btn_footer: config.btn_footer,
        values:{}
      };
      if(
          typeof config.config != "undefined"
          && typeof config.config.methods != "undefined"
      ) {
        dialog.methods = config.config.methods
        //todo nacteni z backedndu
        //console.log('[htmlEditor.prepareDialog] BACKEND', config.config.methods.paths.display)
        this.loadInputsFromBackend(config.config.methods.paths.display);

      } else if(typeof config.inputs != "undefined") {

        dialog.display = true;
        dialog.inputs = config.inputs
        for(const i in config.inputs) {
          //dialog.values[i] = null;
          //console.log('[htmlEditor.prepareDialog] INPUT', i, config.inputs[i])
          if(
              typeof config.inputs[i].defaultValue != "undefined"
              && typeof config.inputs[i].defaultValue != "undefined"
          ) {
            dialog.values[i] = config.inputs[i].defaultValue;
          }else{
            dialog.values[i] = null;
          }
        }
      }

      if(
          this.currentElement.definition.isWrap
          && this.contentSelection.htmlSelection
      ) {
        dialog.innerHTML = this.contentSelection.htmlSelection
      }

      //console.log('[htmlEditor.prepareDialog] dialog', dialog)
      this.dialog = dialog;
    },

    closeDialog(){
      this.dialog.display = false;
    },

    submitDialog(){
      //TODO overeni platnosti
      //console.log('[htmlEditor.submitDialog] dialog', this.dialog.methods.paths.generate)
      let errStatus = false;
      for(const i in this.dialog.inputs) {
        //console.log('[htmlEditor.submitDialog] validation', i, this.dialog.inputs[i], this.dialog.values[i])
        if(this.dialog.inputs[i].isMandatory){
            if(!this.dialog.values[i]) {
              errStatus = true;
              this.dialog.inputs[i].err = 'Toto pole musi byt vyplnene';
            }
        }
      }

      this.dialog.errStatus = errStatus;


      if(!errStatus) {
        this.dialog.display = false;
        this.createDialogElement();
      }else{

      }

      //
    },

    createDialogElement() {
      if(
        this.dialog
        && typeof this.dialog.methods != "undefined"
        && typeof this.dialog.methods.paths != "undefined"
        && typeof this.dialog.methods.paths.generate != "undefined"
        && this.dialog.methods.paths.generate
      ){
        //console.log('[htmlEditor.createDialogElement] X', this.dialog.methods)
        //console.log('[htmlEditor.submitDialog] dialog X', this.dialog.methods.paths.generate)
        let formData = new FormData();
        formData.append('request', 'generate');
        formData.append('innerHTML', this.dialog.innerHTML);
        formData.append('inputs',JSON.stringify(this.dialog.values));

        //console.log('[htmlEditor.createDialogElement] formData', formData, this.dialog)


        let newElement;
        axios.defaults.baseURL = this.getBaseRoot();
        axios({
          method: 'post',
          url: this.dialog.methods.paths.generate.path,
          data: formData,
          withCredentials: true,
          headers: this.getRequestHeader(),
        }).then((res) => {
          //console.log('[htmlEditor.createDialogElement] CUSTOM RES', res.data.response)
          newElement = {
            tagName: res.data.response.element.tag,
            innerHTML: res.data.response.element.innerHTML,
            render_attr : res.data.response.element.render_attr,
            complete_attr: res.data.response.element.complete_attr,
          }
          //console.log('[htmlEditor.createDialogElement] NEW ELEMENT', newElement)
        }).catch(function(err){
          console.log('[htmlEditor.createDialogElement] ERR', err)
        }).finally((data) =>{
          if(newElement) {

            //todo attr

            this.createElement2(
                {
                  tagName: newElement.tagName,
                  innerHtmlPlaceholder: newElement.innerHtmlPlaceholder,
                  innerContent: newElement.innerHTML,
                  attrsDisplay: newElement.render_attr,
                  attrsComplete: newElement.complete_attr
                }
            );


            /*
            this.createElement(
                newElement.tagName,
                newElement.innerHTML,
                newElement.render_attr,
                newElement.complete_attr,
            );
            */
          }
        })

      } else{
        //stanradtni vytvoreni

        const params = {}
        let wrapText = null
        if(this.dialog.innerHTML) {
          wrapText = this.dialog.innerHTML;
        }

        const displayParams = {}
        //console.log('[htmlEditor.createDialogElement] DIALOG #1', this.dialog)
        if(this.dialog.inputs) {
          for(const i in this.dialog.inputs) {
            //console.log('[htmlEditor.createDialogElement] DIALOG #1 item', i, this.dialog.inputs[i])
            if(this.dialog.inputs[i].isRender) {
              if(
                  typeof this.dialog.values[i] != "undefined"
                  && this.dialog.values[i]
              ) {
                displayParams[i] = this.dialog.values[i];
              }else{
                //todo default value?
              }
            }
          }
        }

        //console.log('[htmlEditor.createDialogElement] DIALOG displayParams', displayParams)

        this.createElement2(
            {
              tagName: this.currentElement.definition.tagName,
              innerHtmlPlaceholder: this.currentElement.definition.innerHtmlPlaceholder,
              innerContent: wrapText,

              attrsDisplay: displayParams ,
              attrsComplete: this.dialog.values,
            }
        );

        /*
        this.createElement(
            this.currentElement.definition.tagName,
            wrapText,
            this.dialog.values,
            null,
        );
        */

      }
    },

    loadInputsFromBackend(config) {
      //console.log('[htmlEditor.loadInputsFromBackend] BACKEND', config)
      let formData = new FormData();
      formData.append('subject', this.contentSelection.htmlSelection);

      axios.defaults.baseURL = this.getBaseRoot();
      axios({
        method: 'post',
        url: config.path,
        data: formData,
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        //console.log('[htmlEditor.loadInputsFromBackend] BACKEND RES', res.data.response.form.inputs)
        this.dialog.inputs = res.data.response.form.inputs;
      }).catch(function(err){
        console.error('[htmlEditor.loadInputsFromBackend] ERR', err)
      }).finally((data) =>{
          //this.sendDataToDialog();
          this.dialog.display = true;
      })
    },

    removeElement(ident) {
      //console.log('[htmlEditor.removeElement]', ident, this.contentSelection.elementNode)
      //console.log('[htmlEditor.removeElement] string selection', this.contentSelection.selection.toString())
      if(this.contentSelection.elementNode) {
        //const selectionString = this.contentSelection.selection.toString()
        //console.log('[htmlEditor.removeElement] NODE',  this.contentSelection.elementNode)
        const myRange = new Range();
        //const parentElement = this.contentSelection.elementNode.parentNode
        myRange.selectNode(this.contentSelection.elementNode);
        myRange.deleteContents();
        let nodes = [];
        let firstNode = null
        let lastNode = null
        if(this.contentSelection.elementNode.hasChildNodes()) {
          this.contentSelection.elementNode.childNodes.forEach(node => {
            if(firstNode == null) {
              firstNode = node;
            }
            lastNode = node
            //console.log('[htmlEditor.removeElement] NODE item',  node.nodeType, node)
            if (node.nodeType == Node.TEXT_NODE) {
              const textNodeAppend = document.createTextNode(node.nodeValue);
              nodes.push(textNodeAppend)
            }else {
              nodes.push(node);
            }
          });
        }

        if(nodes && nodes.length) {
          let selectionFirstNode = null;
          let selectionLastNode = null;

          nodes = nodes.reverse();
          const textArr = []
          for (const n in nodes){
            if(!selectionFirstNode) selectionFirstNode = nodes[n]
            selectionLastNode = nodes[n]

            myRange.insertNode(nodes[n]);
            textArr.push(nodes[n].innerText)
          }

          //selection
          document.getSelection().removeAllRanges();
          if(nodes.length > 1) {
            document.getSelection().setBaseAndExtent(
                selectionLastNode,
                0,
                selectionFirstNode,
                selectionFirstNode.childNodes.length
            );
          }else{
            document.getSelection().setBaseAndExtent(
                selectionFirstNode,
                0,
                selectionFirstNode,
                selectionFirstNode.length
            );
          }

          this.callbackCreateElement();
          this.selectElementBySelection();
        }
      }


      //dialog display turn off
      if(
          this.dialog
          && this.dialog.display
      ) {
        this.dialog.display = false;
      }

      //DEVthis.callbackCreateElement();
    },

    createElement2(object) {

      const element = this.createElementStructure(object, true)

      //vlozeni

      if(this.currentElement.action == 'new' ) {
        const myRange = this.contentSelection.range
        myRange.deleteContents();
        myRange.insertNode(element);
      } else if(this.currentElement.action == 'edit' ) {
        const myRange = new Range();
        myRange.selectNode(this.contentSelection.elementNode);
        myRange.deleteContents();
        myRange.insertNode(element);
      }

      //oznaceni vyberem
      /** */
      const selection = window.getSelection();
      selection.removeAllRanges();


      //console.log('[htmlEditor.createElement2] ELEMNT', element)
      //dev
      this.callbackCreateElementSelection(element);
      this.callbackCreateElement();


    },

    createElementStructure(elementData, isRootElement = false){
      console.log('[htmlEditor.createElementStructure] IN', elementData)
      //console.log('[htmlEditor.createElementStructure] elementData', this.contentSelection.htmlSelection, elementData)
      const element = document.createElement(elementData.tagName);

      //child

       if (elementData.child){
        for(const i in elementData.child) {
          element.appendChild(
              this.createElementStructure(elementData.child[i])
          )
        }
      }

      //element.innerHTML = 'this.contentSelection.selectionHTML';
      /***/


      if(elementData.innerContent) {
        element.innerHTML = elementData.innerContent;
      }

      //pokud je placeholder
       if(elementData.innerHtmlPlaceholder) {
        element.innerHTML = this.contentSelection.htmlSelection;
      }



       //atributes
        if(elementData.attrs) {
          for(const i in elementData.attrs) {
            element.setAttribute(i, elementData.attrs[i]);
          }
        }

       if(elementData.attrsDisplay) {
        for(const i in elementData.attrsDisplay) {
          element.setAttribute(i, elementData.attrsDisplay[i]);
        }
        if(!elementData.attrsComplete) {
          elementData.attrsComplete = elementData.attrsDisplay
        }
      }
       //dev

       if(
       elementData.attrsComplete
       && Object.keys(elementData.attrsComplete).length > 0
       ) {
        element.setAttribute(this.config.attributes.element_values_name, JSON.stringify(elementData.attrsComplete));
      }

       //specials
       if(isRootElement) {
        element.setAttribute(this.config.attributes.element_typ_name, this.contentSelection.button);
        element.setAttribute(this.config.attributes.element_id_name, this.generateRandomString());
      }



      return element;
    },


    callbackCreateElementSelection(element){
      //console.log('[htmlEditor.callbackCreateElementSelection] IN', element)
      document.getSelection().setBaseAndExtent(
          element,
          0,
          element,
          element.childNodes.length
      );


      //vyberu a
      const selection = document.getSelection()
      if(
          selection.rangeCount
          && !selection.isCollapsed
      ) {
        const myRange = selection.getRangeAt(0);
        const tempDiv = document.createElement('div');
        tempDiv.appendChild(myRange.cloneContents())
        this.contentSelection.htmlSelection = tempDiv.innerHTML
        this.contentSelection.range = myRange;

        //TODO nefujguje nastaveni buttonu

        const elementType = this.getElementType(selection.focusNode);
        this.contentSelection.button = elementType;
        //console.log('[htmlEditor.callbackCreateElementSelection] elementType', elementType)
        this.contentSelection.elementNode =  selection.focusNode;


        //this.updateButtons()
      }

      /**
      console.log('[htmlEditor.callbackCreateElementSelection] IN2', element.childNodes.length)
      const range = document.createRange();
      const selection = window.getSelection();
      selection.removeAllRanges();

      range.setStart(
          element,
          0
      );
      range.setEnd(
          element,
          element.childNodes.length
      );

      selection.addRange(range.cloneRange());
      this.createMouseSelectFromSearch(range, selection);
      */
    },

    callbackCreateElement() {
      //this.contentSelection.button = null;
      this.contentSelection.htmlSelection = null;
      this.updateButtons()
      this.updateCode();
      this.onEditorChange()
      //this.clearSelection();
    },

    clearCode(){
      //console.log('[htmlEditor.clearCode]')
      //const html = this.$refs.editorWysiwygBody;
      const walker = document.createTreeWalker(this.$refs.editorWysiwygBody, NodeFilter.SHOW_TEXT, null, false);
      //console.log('[htmlEditor.clearCode] html', walker)

      const removeNodes = []
      let node;
      while ( node = walker.nextNode()) {
        //console.log('[htmlEditor.clearCode] node', node.textContent, node.parentNode)


        if(
            node.textContent == '&nbsp;'
            || node.textContent == ' '
            // || !node.textContent
        ) {
          //console.log('[htmlEditor.clearCode] node DELETE', node.textContent, node.parentNode.parentNode)
          removeNodes.push(node);
        }else {
          //console.log('[htmlEditor.clearCode] node TEST', '_'+node.textContent+'_', node.textContent.length)
        }
      }

      if(removeNodes.length) {
        for(const i in removeNodes) {
          //console.log('[htmlEditor.clearCode] res REMOVE', i, removeNodes[i], removeNodes[i].parentNode.outerHTML )

          const myRange = new Range();
          myRange.selectNode(removeNodes[i].parentNode);
          const blankSpace = document.createTextNode(' ');
          myRange.deleteContents();
          myRange.insertNode(blankSpace);
        }
        this.updateCode();
        this.updateEditor();
      }
    },


    clearSelection(){
      console.log('[htmlEditor.clearSelection] TODO')
      //todo vypnout active button
      //this.contentSelection.button = null; //asi jen pro nove?
    },

    isDisplaySpecialButton(ident, method = null) {
      //console.log('[htmlEditor.isDisplaySpecialButton]', ident, method)
      /*
      if(
          method
      ) {
        console.log('[htmlEditor.isDisplaySpecialButton] TODO METHOD x', method)
      }
*/

      if(
          this.displaySpecials[ident]
      ) {
        return true;
      } else {
        return false;
      }
    },

    clickSpecialButton(ident) {
      if(typeof this[ident] == "function") {
        this[ident]();
      }else{
        console.log('[htmlEditor.clickSpecialButton] NEEXISTUJE funkce', ident)
      }
    },

    toggleFullscreen () {
      const element = this.$refs.editorWrap;

      if(this.displaySpecials.fullscreenToggleOn) {
        if (!document.fullscreenElement) {
          element.requestFullscreen().catch(err => {
            //this.displaySpecials.fullscreenToggleOn = true;
            //this.displaySpecials.fullscreenToggleOff = false;
            console.error(`Error attempting to enable fullscreen mode: ${err.message} (${err.name})`);
          });
        } else {
          document.exitFullscreen();
          console.log('onToggleFullscreen exit' )
          //this.displaySpecials.fullscreenToggleOn = true;
          //.displaySpecials.fullscreenToggleOff = false;
        }
      }else{
        document.exitFullscreen();
        //this.displaySpecials.fullscreenToggleOn = true;
        //this.displaySpecials.fullscreenToggleOff = false;
      }

      this.displaySpecials.fullscreenToggleOn = !this.displaySpecials.fullscreenToggleOn;
      this.displaySpecials.fullscreenToggleOff = !this.displaySpecials.fullscreenToggleOff;
    },

    removeElementOther(){
      this.removeElement(null);
      this.displaySpecials.removeElement = false;
    },

    clearFormatComplete() {

      if(confirm(this.$t("wysiwyg.action.clear_format_complete.confirm"))) {
        this.contentSelection.button = null;// vypnuti standartniho aktivniho buttonu
        this.updateButtons()
        const cleanContent = this.$refs.editorWysiwygBody.innerText
        this.$refs.editorWysiwygBody.innerHTML = cleanContent;
        this.updateCode();
        this.dialog.display = false; //pokud je otevreny dialog

      }
    },
    switchEditor() {
      this.editorObj.display = {
        code: !this.editorObj.display.code,
        wysiwyg: !this.editorObj.display.wysiwyg,
      }
    },

    updateSpecialButtonDisplay() {
      //console.log('[htmlEditor.updateSpecialButtonDisplay] this.editorObj.data.code.lenght', this.editorObj.data.code)
      if(this.editorObj.data.code) {
        this.displaySpecials.clearFormatComplete = true;
      }else{
        this.displaySpecials.clearFormatComplete = false;
      }
      this.displaySpecials.clearFormatComplete = true;
    },

    switchSearchDisplay() {
      this.searchObj.display = !this.searchObj.display;
      //console.log('[htmlEditor.switchSearchDisplay]', this.searchObj)
    },

    switchHelp() {
      this.helpObj.display  = !this.helpObj.display;
      console.log('[htmlEditor.switchHelp]', this.searchObj)
    },
    isHelpObj() {
      let status = false;
      let structure = {
       // 'dev': null,
      };




      if(this.buttons){
        const buttonsIdent = 'buttons'
        const specialIdent = 'specials'
        structure[buttonsIdent] = {
          title: 'wysiwyg.section.action.title',
          ico: null,
          display: true,
          items: {}
        }

        structure[specialIdent] = {
          title: 'wysiwyg.section.special.title',
          ico: null,
          display: false,
          items: {}
        }


        //btns
        for(const i in this.buttons) {
          if(this.buttons[i].help) {
            structure[buttonsIdent].items[i] = {
              title: this.buttons[i].title,
              ico: this.buttons[i].ico,
              content: this.buttons[i].help,
              display: false,
            }
            status = true;
          }
        }
        //specials
        for(const i in this.specialsDefinition) {
          if(this.specialsDefinition[i].help) {
            structure[specialIdent].items[i] = {
              title: this.specialsDefinition[i].title,
              ico: this.specialsDefinition[i].ico,
              content: this.specialsDefinition[i].help,
              display: false,
            }
            status = true;
          }
        }

      }

      //check
      for(const s in structure){
        if(Object.keys(structure[s].items).length == 0 ){
          delete structure[s];
        }
      }


      this.helpObj.data = structure
      this.displaySpecials.help = status
    },

    toogleHelpItem(section, item = null) {

      for(const s in this.helpObj.data){
        this.helpObj.data[s].display = false;



        if(s == section) {
          this.helpObj.data[s].display = true;
          if(
              item
              && Object.keys(this.helpObj.data[s].items).length > 0
          ){
            for(const i in this.helpObj.data[s].items){
              this.helpObj.data[s].items[i].display = false;
              if(s == section && i == item) {
                this.helpObj.data[s].items[i].display = true;
              }
            }
          }
        }
      }
    },



    replaceInWysiwyg() {
      const editorWrap = this.$refs.editorWysiwygBody;
      this.searchObj.err = null;
      this.searchObj.phrase = this.searchObj.model
      console.log('[htmlEditor.replaceInWysiwyg]', this.searchObj.phrase.length)
      if(
          this.searchObj.phrase.length > 0
      ) {
          if(this.searchObj.replacePhrase === null) {
            this.searchObj.replacePhrase = '';
          }

        let countReplace = 0;
        const regexSearch = new RegExp(this.searchObj.phrase, "gi");
        const walker = document.createTreeWalker(editorWrap, NodeFilter.SHOW_TEXT, null, false);
        const results = {}

        //let nodeIndex = 0;
        let node;
        while ( node = walker.nextNode()) {
          let match;
          while (
              (match = regexSearch.exec(node.textContent)) !== null
          ) {

              countReplace++;
              const newTextContent = node.textContent.replace(
                  regexSearch,
                  this.searchObj.replacePhrase
              );
              console.log('[htmlEditor.replaceInWysiwyg] newTextContent', newTextContent)
              node.textContent = newTextContent;
          }
        }

        if(countReplace > 0) {
          this.searchObj.info = 'nahrazeno: ' + countReplace + 'x';
        }else{
          this.searchObj.err = "Nenalezen zadny vyskyt fraze '" + this.searchObj.phrase + "'"
        }


      }else{
        this.searchObj.err = "Pro nahrazeni musi zadat vyhledavanou frazi"
      }
      console.log('[htmlEditor.replaceInWysiwyg]', this.searchObj)
    },

    searchInWysiwyg() {
      //console.log('[htmlEditor.searchInWysiwyg]', this.searchObj)
      const editorWrap = this.$refs.editorWysiwygBody;

      if(this.searchObj.model) {
        if(this.searchObj.model != this.searchObj.phrase) {
          this.searchObj.phrase = this.searchObj.model

          const regexSearch = new RegExp(this.searchObj.phrase, "gi");
          const walker = document.createTreeWalker(editorWrap, NodeFilter.SHOW_TEXT, null, false);
          const results = {}

          let nodeIndex = 0;
          let node;
          while ( node = walker.nextNode()) {
            let match;
            while (
                (match = regexSearch.exec(node.textContent)) !== null
            ) {
              nodeIndex++;
              //console.log('[htmlEditor.searchInWysiwyg] RESULTS', this.searchObj.phrase.length)
              results[nodeIndex] = {
                //i: nodeIndex,
                node: node,
                text: node.textContent,
                offset: match.index,
                text_leng: this.searchObj.phrase.length,
                node_leng: node.textContent.length,
              }
            }
          }
          //
          this.searchObj.results = results;
          this.searchObj.resultIndex = 0;
          if(
              this.searchObj.results
              && Object.keys(this.searchObj.results).length > 0
          ) {
            this.searchObj.resultIndex = 1;
          }else{
            this.searchObj.err = "Nenalezen zadny vyskyt fraze '" + this.searchObj.phrase + "'"
            this.searchObj.info = null;
          }
        }else{
          this.searchObj.resultIndex++;
        }

        if(
            typeof this.searchObj.results[this.searchObj.resultIndex] != "undefined"
            && this.searchObj.results[this.searchObj.resultIndex]
        ){

          this.searchObj.info = 'Výskyt: ' +this.searchObj.resultIndex + '/' + Object.keys(this.searchObj.results).length

          const range = document.createRange();
          const selection = window.getSelection();
          selection.removeAllRanges();

          range.setStart(
              this.searchObj.results[this.searchObj.resultIndex].node,
              this.searchObj.results[this.searchObj.resultIndex].offset
          );
          range.setEnd(
              this.searchObj.results[this.searchObj.resultIndex].node,
              this.searchObj.results[this.searchObj.resultIndex].offset + this.searchObj.results[this.searchObj.resultIndex].text_leng
          );
          selection.addRange(range.cloneRange());
          this.createMouseSelectFromSearch(range, selection);

          if(
              typeof this.searchObj.results[this.searchObj.resultIndex +1] == "undefined"
          ) {
             this.searchObj.resultIndex = 0;
          }
        }
      }

    },

    cleanSearchResults() {
      this.searchObj.phrase = null;
      this.searchObj.results = null;
      this.searchObj.resultIndex = null;
    },

    createMouseSelectFromSearch(range, selection) {
      this.contentSelection.selection = selection;
      this.contentSelection.range = range;
      this.contentSelection.isCollapsed =  this.contentSelection.selection.isCollapsed;

      if(window.getSelection()){
        this.contentSelection.innerText =  '' + selection
      }
      this.updateButtons();
      //this.updateCode();
    },

    // -----------------------------------------------------------
    getElementType(element) {
      //console.log('[htmlEditor.getElementType] attr', this.config.attributes.element_typ_name)
      let elementType = element.tagName;
      if(element && element.getAttribute(this.config.attributes.element_typ_name)) {
        elementType = element.getAttribute(this.config.attributes.element_typ_name) //'data-special-type'
      }
      return elementType.toLowerCase();
    },

    generateRandomString() {
      const length = 20;
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      const charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }

      return result;
    },

    onRichInput(event) {
      let value = event.target.innerHTML
      value = value.replaceAll('&nbsp;', ' ');
      this.setNestedValue(this, event.target.getAttribute('data-name'), value)
      if(this.config.timerObj.renderDelay) clearInterval(this.config.timerObj.renderDelay);
      this.config.timerObj.typeCode = setTimeout(
          () => {
            document.getSelection().setBaseAndExtent(event.target, event.target.childNodes.length, event.target, event.target.childNodes.length);
          },
          this.config.timer.renderDelay
      )
    },

    getNestedValue(obj, path) {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    },

    setNestedValue(obj, path, value) {
      const keys = path.split('.');
      const lastKey = keys.pop();
      const target = keys.reduce((acc, key) => acc[key] = acc[key] || {}, obj);
      target[lastKey] = value;
    }
  },
  watch: {
    "editorObj.data.code": {
      handler(newVal, oldVal) {
        if(newVal !== null) {
          if(newVal == '') {
            newVal = null;
          }
          this.$emit('update:modelValue', newVal)
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>